import script from "./EditFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditFormPage.vue?vue&type=script&setup=true&lang=js"

import "./EditFormPage.vue?vue&type=style&index=0&id=2fff9664&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fff9664"]])

export default __exports__